(($) => $.fn.extend({
  removeClassBy(prefix) {
    const classes = this.attr('class').split(' ').filter((c) => c.lastIndexOf(prefix, 0) !== 0);
    return this.attr('class', classes.join(' '));
  }
}))(jQuery);
